import { render } from "./MailStatusTypeComponent.vue?vue&type=template&id=69d713d2&scoped=true"
import script from "./MailStatusTypeComponent.vue?vue&type=script&lang=js"
export * from "./MailStatusTypeComponent.vue?vue&type=script&lang=js"

import "./MailStatusTypeComponent.vue?vue&type=style&index=0&id=69d713d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d713d2"]])

export default __exports__